// src/scripts/vendor/inline-zoom.js
var InlineImageZoom = class extends HTMLElement {
  constructor() {
    super();
    this.img = null;
    this.scale = Number(this.dataset.zoomScale || 2);
    this.isZoomed = false;
  }
  connectedCallback() {
    if (window.matchMedia("(hover: none)").matches) return;
    this.img = this.querySelector("img");
    if (!this.img) return;
    this.style.overflow = "hidden";
    this.img.style.transition = "transform 0.15s ease-out";
    this.img.style.transformOrigin = "center";
    this.addEventListener("click", this.toggleZoom);
    this.addEventListener("mousemove", this.onMove);
    this.addEventListener("mouseleave", this.reset);
  }
  toggleZoom = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.isZoomed = !this.isZoomed;
    this.classList.toggle("is-zoomed", this.isZoomed);
    if (!this.isZoomed) {
      this.reset();
      return;
    }
    const zoomSrc = this.img.dataset.zoomSrc;
    if (zoomSrc && this.img.src !== zoomSrc) {
      this.img.src = zoomSrc;
    }
    const rect = this.getBoundingClientRect();
    const x = (e.clientX - rect.left) / rect.width * 100;
    const y = (e.clientY - rect.top) / rect.height * 100;
    this.img.style.transformOrigin = `${x}% ${y}%`;
    this.img.style.transform = `scale(${this.scale})`;
  };
  onMove = (e) => {
    if (!this.isZoomed) return;
    const rect = this.getBoundingClientRect();
    const x = (e.clientX - rect.left) / rect.width * 100;
    const y = (e.clientY - rect.top) / rect.height * 100;
    this.img.style.transformOrigin = `${x}% ${y}%`;
    this.img.style.transform = `scale(${this.scale})`;
  };
  reset = () => {
    this.isZoomed = false;
    this.classList.remove("is-zoomed");
    this.img.style.transform = "";
    this.img.style.transformOrigin = "center";
  };
};
if (!customElements.get("inline-image-zoom")) {
  customElements.define("inline-image-zoom", InlineImageZoom);
}
